import { Component } from '@angular/core'
import { PostActions } from 'actions/post-actions'
import { BasePostForm } from './base-post-form.component'
import { postInContext } from 'logic/post-states'

@Component({
  selector: 'post-review-form',
  styles: [`
    label {
      font-weight: normal;
    }
  `],
  template: `
    <h4>Leave a review</h4>
    <form (ngSubmit)="onSubmit()">
      <p>You're leaving a review for this writer.</p>
      <p>This could include a word of thanks, encouragement, or some constructive criticism of their work.</p>
      <div *ngIf="post?.appPostReview && !editing">
        <p class="small text-muted">
          Review:
          <a class="cursor-pointer" (click)="editing = true">edit</a>
        </p>
        <p class="horizontal-padding">
          <span class="italics line-breaker">{{post.appPostReview.content}}</span>
        </p>
      </div>
      <div class="form-group" *ngIf="editing || !post?.appPostReview">
        <textarea rows="2" class="form-control textarea-mobile" name="comments" [ngModel]="comments" (ngModelChange)="onModelChange('comments', $event)" (focus)="$event.target.rows = 6"
          placeholder="Let the writer know what you liked and what they could maybe improve on next time around.">
        </textarea>
      </div>
      <button *ngIf="editing || !post?.appPostReview" type="submit" class="btn btn-primary float-right" [disabled]="submitted || comments.length === 0">
        <span *ngIf="!submitted">Submit</span>
        <span *ngIf="submitted">Please wait...</span>
      </button>
      <button type="button" class="btn btn-default float-right" style="margin-right: 10px;" (click)="onClose()">{{editing || !post?.appPostReview ? 'Cancel' : 'Close'}}</button>
      <div style="clear: both;"></div>
    </form>
  `,
})
export class PostReviewForm extends BasePostForm {
  comments: string = '';
  editing: boolean = false;

  constructor(private postActions: PostActions) {
    super()
  }

  ngOnInit(): void {
    this.comments = this.post.appPostReview?.content || ''
  }

  onSubmit(): void {
    if (!this.submitted) {
      this.submitted = true
      this.postActions.leaveReview(this.customer.id, this.post.id, this.comments).then(() => {
        this.submitted = false
        this.setDirty(false)
        this.onClose()
        this.deprecatedStoreChange.emit(this.post.id)
      })
      .catch(() => {
        this.submitted = false
      })
    }
  }

  postInContext(context: string): boolean {
    return postInContext(this.post, context)
  }
}
